import { jsx as _jsx } from "react/jsx-runtime";
// ui/styles.css imports the same stylesheet for every product host.
/** Comment actions wrap within their editor without hiding a label or action. */
export function ComposerActions({ children, separated = false }) {
    return _jsx("div", { className: `oq-composer__actions${separated ? ' oq-composer__actions--separated' : ''}`, children: children });
}
//# sourceMappingURL=ComposerActions.js.map